function resizeMasonryItem(item) {
  var grid = document.getElementsByClassName('masonry')[0];
  if (!grid || !item) return;

  var content = item.querySelector('.masonry-content');
  if (!content) return;

  var rowGap = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-row-gap'), 10);
  var rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-auto-rows'), 10);
  var rowSpan = Math.ceil((content.getBoundingClientRect().height + rowGap) / (rowHeight + rowGap));

  item.style.gridRowEnd = 'span ' + rowSpan;
  content.style.height = rowSpan * 10 + 'px';
}

function resizeAllMasonryItems() {
  var allItems = document.getElementsByClassName('masonry-item');
  for (var i = 0; i < allItems.length; i++) {
    resizeMasonryItem(allItems[i]);
  }
}

function waitForMasonryImages() {
  var allItems = document.getElementsByClassName('masonry-item');
  if (!allItems || !allItems.length) return;

  for (var i = 0; i < allItems.length; i++) {
    (function (item) {
      var images = item.querySelectorAll('img');
      if (!images.length) {
        resizeMasonryItem(item);
        return;
      }

      var pending = images.length;
      var done = function () {
        pending -= 1;
        if (pending <= 0) resizeMasonryItem(item);
      };

      for (var j = 0; j < images.length; j++) {
        if (images[j].complete) {
          done();
        } else {
          images[j].addEventListener('load', done, { once: true });
          images[j].addEventListener('error', done, { once: true });
        }
      }
    })(allItems[i]);
  }
}

waitForMasonryImages();
window.addEventListener('resize', resizeAllMasonryItems);

window.onload = function () {
  var collectionContainer = document.querySelectorAll('.collection');
  collectionContainer.forEach(function (element) {
    var loadingGrid = element.querySelector('#loading-grid');
    if (!loadingGrid || loadingGrid.classList.contains('loading-remove')) return;

    setInterval(function () {
      loadingGrid.classList.add('loading-remove');
    }, 100);
  });
};
